import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { KidhLogo } from "./Logo";

const NAV_ITEMS = [
  { label: "Philosophie", href: "#philosophie" },
  { label: "Vision 2035", href: "#vision" },
  { label: "Écosystème", href: "#ecosysteme" },
  { label: "Nos Pôles", href: "#poles" },
  { label: "Projets", href: "#projets" },
  { label: "Votre Projet", href: "#configurateur" },
  { label: "Contact", href: "#contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="kidh-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAFAF8]/95 backdrop-blur-md shadow-[0_1px_0_rgba(12,35,64,0.08)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-40">
        <a href="#top" className="shrink-0" data-testid="header-logo-link">
          <KidhLogo inverse={!scrolled} useImage />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.slice(1)}`}
              className={`font-body text-[0.72rem] uppercase tracking-[0.22em] font-medium transition-colors ${
                scrolled ? "text-[#0C2340] hover:text-[#E8611A]" : "text-white/85 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="header-cta"
            className={`ml-4 font-body text-[0.72rem] uppercase tracking-[0.22em] font-semibold px-5 py-2.5 transition-all ${
              scrolled
                ? "bg-[#E8611A] text-white hover:bg-[#0C2340]"
                : "border border-white/70 text-white hover:bg-white hover:text-[#0C2340]"
            }`}
          >
            Nous rejoindre
          </a>
        </nav>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen(true)}
          aria-label="Ouvrir le menu"
          data-testid="header-menu-open"
        >
          <Menu className={scrolled ? "text-[#0C2340]" : "text-white"} size={26} />
        </button>
      </div>

      {/* Mobile overlay menu */}
      {open && (
        <div
          className="fixed inset-0 z-[60] bg-[#0C2340] text-white flex flex-col p-8 animate-fade-in"
          data-testid="mobile-menu"
        >
          <div className="flex items-center justify-between">
            <KidhLogo inverse useImage />
            <button
              onClick={() => setOpen(false)}
              aria-label="Fermer le menu"
              className="p-2"
              data-testid="header-menu-close"
            >
              <X size={28} />
            </button>
          </div>
          <nav className="flex flex-col gap-6 mt-16">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="font-heading font-bold text-2xl uppercase tracking-tight hover:text-[#E8611A] transition-colors"
                data-testid={`mobile-nav-${item.href.slice(1)}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="kidh-btn-primary mt-4 w-fit"
            >
              Nous rejoindre
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
